import { render, staticRenderFns } from "./Home.pug?vue&type=template&id=10986bee&lang=pug&"
import script from "./Home.js?vue&type=script&lang=js&"
export * from "./Home.js?vue&type=script&lang=js&"
import style0 from "./Home.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports